import CSVMapping, { Field } from '~/types/CSVMapping';
import { ActionKeys } from './constants';
import { TrackingReference } from '~/utils/TrackingHelper/types';

export function uploadCSV(file: string | Blob) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_FILE_UPLOAD,
    payload: {
      file,
    },
  };
}

export type UploadCSVPayload = {
  fileUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userValues: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapping: any;
};

// TODO: Remove payload type and pass params directly to functions
export function uploadCSVSuccess(payload: UploadCSVPayload) {
  return <const>{
    payload,
    type: ActionKeys.CSV_IMPORT_FILE_UPLOAD_SUCCESS,
  };
}

// TODO: Add types to function params
export function uploadCSVError(errorMessage: string, errorTitle: string) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_FILE_UPLOAD_ERROR,
    payload: {
      errorMessage,
      errorTitle,
    },
  };
}

export function changeCSVFieldMapping(index: number, field: Field, colName: string) {
  return <const>{
    payload: {
      field,
      index,
      colName,
    },
    type: ActionKeys.CSV_IMPORT_CHANGE_FIELD_MAPPING,
  };
}

export function changeCSVTemplate(value: number) {
  return <const>{
    value,
    type: ActionKeys.CSV_IMPORT_CHANGE_TEMPLATE,
  };
}

export function fetchCSVTemplates() {
  return <const>{
    type: ActionKeys.CSV_IMPORT_FETCH_TEMPLATES,
  };
}

interface FetchCSVTemplatesSuccessPayload {
  templates: CSVMapping[];
}

// TODO: Remove payload type and pass templates directly to functions
export function fetchCSVTemplatesSuccess(payload: FetchCSVTemplatesSuccessPayload) {
  return <const>{
    payload,
    type: ActionKeys.CSV_IMPORT_FETCH_TEMPLATES_SUCCESS,
  };
}

// TODO: Add types to function params
export function fetchCSVTemplatesError(errorMessage: string, errorTitle: string) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_FETCH_TEMPLATES_ERROR,
    payload: {
      errorMessage,
      errorTitle,
    },
  };
}

// TODO: Add types to function params
export function saveCSVTemplate(
  template: unknown,
  isActive: boolean,
  name: string,
  trackingReference: TrackingReference,
  fileUrl?: string,
) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_SAVE_TEMPLATE,
    payload: {
      template,
      isActive,
      name,
      trackingReference,
      fileUrl,
    },
  };
}

export function showDeleteCSVTemplateModal() {
  return <const>{
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE_MODAL_OPEN,
  };
}

// TODO: Add types to function params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deleteCSVTemplate(templateId: any) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE,
    payload: {
      templateId,
    },
  };
}

// TODO: Add types to function params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deleteCSVTemplateSuccess(payload: any) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE_SUCCESS,
    payload: {
      deletedTemplateId: payload.deletedTemplateId,
      templates: payload.templates,
    },
  };
}

export function deleteCSVTemplateError(errorMessage: string, errorTitle: string) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE_ERROR,
    payload: {
      errorMessage,
      errorTitle,
    },
  };
}

// TODO: Add types to function params
export function saveCSVTemplateSuccess(
  fileUrl: string,
  templateId: unknown,
  trackingReference: TrackingReference,
) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_SAVE_TEMPLATE_SUCCESS,
    payload: {
      fileUrl,
      templateId,
      trackingReference,
    },
  };
}

// TODO: Add types to function params
export function saveCSVTemplateError(errorMessage: string, errorTitle: string) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_SAVE_TEMPLATE_ERROR,
    payload: {
      errorMessage,
      errorTitle,
    },
  };
}

export function openSaveCSVModal() {
  return <const>{
    type: ActionKeys.CSV_IMPORT_OPEN_SAVE_CSV_TEMPLATE_MODAL,
  };
}

export function closeSaveCSVModal() {
  return <const>{
    type: ActionKeys.CSV_IMPORT_CLOSE_SAVE_CSV_TEMPLATE_MODAL,
  };
}

export function importCSVOrders(
  fileUrl: unknown,
  templateId: unknown,
  trackingReference: TrackingReference,
) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_ORDERS,
    payload: {
      fileUrl,
      templateId,
      trackingReference,
    },
  };
}

export function importCSVOrdersSuccess() {
  return <const>{
    type: ActionKeys.CSV_IMPORT_ORDERS_SUCCESS,
  };
}

export function importCSVOrdersError(errorMessage: string, errorTitle: string) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_ORDERS_ERROR,
    payload: {
      errorMessage,
      errorTitle,
    },
  };
}

// TODO: Add types to function params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function openErrorMessageBox(text: any, fields: any) {
  return <const>{
    type: ActionKeys.CSV_IMPORT_OPEN_ERROR_MESSAGE,
    payload: {
      text,
      fields,
    },
  };
}

export function closeErrorModal() {
  return <const>{
    type: ActionKeys.CSV_IMPORT_CLOSE_ERROR_MODAL,
  };
}

export function cleanState() {
  return <const>{
    type: ActionKeys.CSV_CLEAN_STATE,
  };
}

export type CSVImportActions =
  | ReturnType<typeof uploadCSV>
  | ReturnType<typeof uploadCSVSuccess>
  | ReturnType<typeof uploadCSVError>
  | ReturnType<typeof changeCSVFieldMapping>
  | ReturnType<typeof changeCSVTemplate>
  | ReturnType<typeof fetchCSVTemplates>
  | ReturnType<typeof fetchCSVTemplatesSuccess>
  | ReturnType<typeof fetchCSVTemplatesError>
  | ReturnType<typeof saveCSVTemplate>
  | ReturnType<typeof showDeleteCSVTemplateModal>
  | ReturnType<typeof deleteCSVTemplate>
  | ReturnType<typeof deleteCSVTemplateSuccess>
  | ReturnType<typeof deleteCSVTemplateError>
  | ReturnType<typeof saveCSVTemplateSuccess>
  | ReturnType<typeof saveCSVTemplateError>
  | ReturnType<typeof openSaveCSVModal>
  | ReturnType<typeof closeSaveCSVModal>
  | ReturnType<typeof importCSVOrders>
  | ReturnType<typeof importCSVOrdersSuccess>
  | ReturnType<typeof importCSVOrdersError>
  | ReturnType<typeof openErrorMessageBox>
  | ReturnType<typeof closeErrorModal>
  | ReturnType<typeof cleanState>;
